export default {
  methods: {
    // Get month name from month no (0-11)
    monthName(monthNo) {
      if (monthNo < 0 || monthNo > 11) return '';
      return ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'][monthNo];
    },
  },
};


// WEBPACK FOOTER //
// ./components/shared/mixins/DateMixin.js